// src/components/intake/IntakeFollowUp.js
//
// Ticket 061. One question with a list of choices, an optional "Not sure"
// button, and an optional label. `sub` indents it as a follow-up under another
// answer. `fact` is the stored answer ({status, value?}) or undefined.
// Options are { value, label }. Nothing here defines an option list.

import React from 'react'
import IntakeOptionButton from './IntakeOptionButton'
import { NOT_SURE_LABEL } from '../../lib/intake/intakeConfig'
import { known, unknown } from '../../lib/intake/section1Facts'

export default function IntakeFollowUp({ question, hint, options, fact, onPick, notSure = false, sub = false }) {
  const body = (
    <>
      {question && (sub
        ? <p className="triage-subquestion-label">{question}</p>
        : <div className="u-form-label">{question}</div>)}
      {hint && <p className="u-hint">{hint}</p>}
      <div className="u-stack-xs">
        {options.map((opt) => (
          <IntakeOptionButton
            key={String(opt.value)}
            label={opt.label}
            selected={!!fact && fact.status === 'known_value' && fact.value === opt.value}
            onClick={() => onPick(known(opt.value))}
          />
        ))}
        {notSure && (
          <IntakeOptionButton
            label={NOT_SURE_LABEL}
            selected={!!fact && fact.status === 'unknown'}
            onClick={() => onPick(unknown())}
          />
        )}
      </div>
    </>
  )
  return sub ? <div className="triage-subquestion">{body}</div> : <div className="u-stack-sm">{body}</div>
}
